export default "__VITE_ASSET__BanmjLbB__"